<template>
  <div class="tab-content">
    <b-row class="mb-3">
      <b-col cols="12">
        <LayoutCard @descargar="$emit('descargarLayout')" />
      </b-col>
    </b-row>

    <ZonaCargaArchivo :archivo.sync="archivoLocal" @update:archivo="$emit('update:archivo', $event)" />

    <b-row class="mt-4">
      <b-col cols="12">
        <ColumnasObligatorias />
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col cols="12" class="text-right">
        <b-button variant="primary" class="btn-guardar mr-3 rounded-pill" @click="$emit('procesar')" :disabled="!archivoLocal || !archivoValido">
          Procesar archivo
        </b-button>
        <b-button variant="secondary" class="btn-cancelar rounded-pill" @click="$emit('cancelar')">
          Cancelar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import ZonaCargaArchivo from './ZonaCargaArchivo.vue';
import ColumnasObligatorias from './ColumnasObligatorias.vue';

export default {
  components: {
    LayoutCard,
    ZonaCargaArchivo,
    ColumnasObligatorias
  },
  props: {
    archivo: {
      type: File,
      default: null
    },
    archivoValido: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      archivoLocal: null
    }
  },
  watch: {
    archivo(newVal) {
      this.archivoLocal = newVal;
    }
  },
  mounted() {
    this.archivoLocal = this.archivo;
  }
}
</script>

<style scoped>

.btn-guardar {
  background-color: #0046A2;
  border-color: #0046A2;
  padding: 8px 20px;
}

.btn-guardar:hover {
  background-color: #003880;
  border-color: #003880;
}

.btn-cancelar {
  background-color: #6c757d;
  border-color: #6c757d;
  padding: 8px 20px;
}

.btn-cancelar:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
</style>